<template>
    <v-container fluid grid-list-sm class="home text-xs-center">
        <v-layout align-center justify-center row pa-5 mb-8>
            <v-flex xs12 sm10 md6>
<!--                <div>-->
<!--                    <pdf-->
<!--                        v-for="i in numPages"-->
<!--                        :key="i"-->
<!--                        :src="src"-->
<!--                        :page="i"-->
<!--                    ></pdf>-->
<!--                </div>-->
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import pdf from 'vue-pdf'
import EventBus from "@/EventBus";

// let loadingTask = pdf.createLoadingTask('https://mediacenter.lpn.co.th/files/asset/Parcel/ParcelManual.pdf');

export default {
    name: "ParcelManual",
    components: {
        pdf
    },
    mounted() {
        window.open('https://mediacenter.lpn.co.th/files/asset/Parcel/ParcelManual.pdf')
        window.scrollTo(0, 0)
        EventBus.$emit('set_navigation', {title: 'คู่มือพัสดุ', back_route: 'main-menu'});
        this.$router.push({name: 'main-menu'})
        // this.src.promise.then(pdf => {
        //     this.numPages = pdf.numPages;
        // });
    },
    // data() {
    //     return {
    //         src: loadingTask,
    //         numPages: '',
    //     }
    // },
}
</script>

<style scoped>

</style>